<template>
  <section
    v-if="acf.enabled && enabled"
    :mode="$root.mode"
    class="component-z49ajfa5"
    resmed-component-name="video_gallery_intro_animation_bgimg_title"
    v-bind:style="{
      'background-color': `${acf[activeLayoutScene].layout['background-color']}`,
    }"
  >
    <transition
      enter-active-class="fade-in-zoom"
      leave-active-class="fade-out-zoom"
    >
      <div
        :key="activeLayoutScene"
        class="animated background-img"
        :style="{
          'background-size': acf[activeLayoutScene].layout['background-size'],
          'background-image': `url(${acf[activeLayoutScene].layout['background-image']})`,
        }"
      ></div>
    </transition>

    <div class="component">
      <div class="stage">
        <transition enter-active-class="fade-in" leave-active-class="fade-out">
          <div
            key="intro"
            class="intro animated -fast"
            v-if="activeScene === 'intro'"
          >
            <div class="intro-slide">
              <div class="left">
                <transition
                  name="custom-slide-in-out-transition"
                  enter-active-class="slide-in-up"
                  leave-active-class="slide-out-up"
                >
                  <h1
                    class="animated -fast"
                    :key="slide.animated_text"
                    v-if="activeSlideIndex === sIdx"
                    v-for="(slide, sIdx) in acf.intro.slides"
                  >
                    {{ slide.animated_text }}
                  </h1>
                </transition>
              </div>
              <div class="right">
                <transition
                  name="custom-fade-in-out-transition"
                  enter-active-class="fade-in"
                  leave-active-class="fade-out"
                >
                  <h1
                    class="animated -fast"
                    :key="slide.static_text"
                    v-if="activeSlideIndex === sIdx"
                    v-for="(slide, sIdx) in acf.intro.slides"
                  >
                    <span class="safari-font-alignment-fix">&#65279;</span
                    >{{ slide.static_text }}
                  </h1>
                </transition>
              </div>
            </div>
          </div>

          <div
            key="finale"
            class="finale animated -fast"
            v-if="activeScene === 'finale'"
          >
            <div class="finale-slide">
              <h1 v-html="acf.finale.content"></h1>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
import ImageHelpers from "../../mixins/image-helpers";

if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

export default {
  name: "component-z49ajfa5", // video_gallery_intro_animation_bgimg_title
  props: ["acf"],
  mixins: [ImageHelpers],
  data() {
    return {
      enabled: true,

      activeLayoutScene: "intro",
      activeScene: null,
      activeSlideIndex: 0,
      introScenePosition: 0,

      animationDelayTimeout: null,
      animationInterval: null,
    };
  },
  created() {
    bus.$emit("navigation:reversed", true);

    bus.$on(
      "video_gallery_feature_story_6:visible",
      () => (this.enabled = false)
    );

    this.preloadImages(
      [
        this.acf.intro.layout["background-image"],
        this.acf.finale.layout["background-image"],
      ].filter((url) => url)
    );

    $(window).on("resize", () => {
      if (this.enabled && document.body.scrollTop > 0) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    });
  },
  mounted() {
    if (this.acf.enabled) {
      this.restartAnimation();
    } else {
      bus.$emit("video_gallery_intro_animation_bgimg_title:complete", {
        shouldAnimate: this.acf.enabled,
      });
    }
  },
  methods: {
    restartAnimation() {
      $("body").addClass("overflow-hidden-z49ajfa5");

      if (this.animationDelayTimeout) {
        clearTimeout(this.animationDelayTimeout);
      }

      if (this.animationInterval) {
        clearInterval(this.animationInterval);
      }

      // start the animation after a 1 second delay
      this.animationDelayTimeout = setTimeout(() => {
        this.activeScene = "intro";
        this.activeLayoutScene = "intro";
        this.activeSlideIndex = 0;

        this.animationInterval = setInterval(() => {
          // if the scene is the intro (or null)
          if (!this.activeScene || this.activeScene === "intro") {
            if (this.activeSlideIndex + 1 > this.acf.intro.slides.length - 1) {
              this.activeSlideIndex = 0;
              this.activeLayoutScene = "finale";
              this.activeScene = "finale";
            } else {
              this.activeSlideIndex = this.activeSlideIndex + 1;
            }
            // kill the animation
          } else {
            clearTimeout(this.animationInterval);
            this.activeScene = null;
            bus.$emit("video_gallery_intro_animation_bgimg_title:complete", {
              shouldAnimate: this.acf.enabled,
            });
            setTimeout(() => {
              $("body").removeClass("overflow-hidden-z49ajfa5");
            }, 0);
          }
        }, 2000);
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/abstracts/animations";

.component-z49ajfa5 {
  background-position: center center;
  background-repeat: no-repeat;
  position: fixed;
  z-index: 10;
  top: 9.5rem;
  left: 0;
  right: 0;
  bottom: 0;

  @media (max-width: 991px) {
    top: 6rem;
  }

  @media (max-width: 767px) {
    top: 4rem;
  }

  .component {
    height: 100%;

    .stage {
      height: 100%;
    }
  }

  .background-img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    background-position: center bottom;
    background-repeat: no-repeat;
  }

  .intro {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;

    &.animated {
      position: absolute;
    }

    .intro-slide {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      .animated {
        position: absolute;
      }

      .left,
      .right {
        width: 50%;
        position: relative;
        min-height: 5em;
      }

      .left {
        text-align: right;

        .animated {
          right: 0.25em;
        }
      }

      .right {
        flex-shrink: 0;
        flex-grow: 1;

        h1 {
          font-family: "Plus Jakarta Sans", sans-serif;
          font-weight: 700;

          .safari-font-alignment-fix {
            font-family: "Plus Jakarta Sans", sans-serif;
            font-weight: 400;
          }
        }
      }
    }
  }

  .finale {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;

    &.animated {
      position: absolute;
    }

    .finale-slide {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      max-width: 500px;
      text-align: center;

      >>> b,
      em {
        font-family: "Plus Jakarta Sans", sans-serif;
        font-weight: 700;
      }
    }
  }
}

@keyframes slide-in-up {
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
    opacity: 0;
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes slide-out-up {
  from {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }

  to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
}

.slide-in-up {
  animation-name: slide-in-up;
}

.slide-out-up {
  animation-name: slide-out-up;
}

.fade-in {
  animation-name: fade-in;
}

.fade-out {
  animation-name: fade-out;
}

.fade-in-zoom {
  animation-name: fade-in-zoom;
}

.fade-out-zoom {
  animation-name: fade-out-zoom;
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-delay: 0s;

  &.-fast {
    animation-duration: 0.5s;
  }
}

.component {
  h1 {
    margin: 0 0 1rem 0;

    &.s54 {
      // default size
    }

    &.s81 {
      @extend %display;
    }
  }

  h1,
  h4 {
    color: $cc-resmed-white;
  }

  h4 {
    font-weight: 400;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 500;
    margin-bottom: 0;
  }
}
</style>

<style lang="scss">
.finale-slide {
  b,
  em {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 700;
  }
}

body.overflow-hidden-z49ajfa5 {
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>